<template>
  <div class="land-home-solutionBg">
    <el-row class="land-solution-case">
      <el-row class="solution-case-title">应用标杆案例</el-row>
      <el-row
        :gutter="12"
        type="flex"
        justify="center" v-if="isThree"
      >
        <el-col
          v-for="(item, index) in benchmarkCaseList"
          :key="index"
        >
          <el-card shadow="hover">
            <el-row class="solution-case-img"><img :src="item.imageUrl" /></el-row>
            <el-row class="solution-case-text">
              <el-row class="solution-title">{{item.title}}
              </el-row>
              <el-row class="solution-text">{{item.description}}
              </el-row>
              <el-row class="solution-btn">
                <a
                  :href="item.referringSite"
                  target="_blank"
                >
                  <el-button>查看详情</el-button>
                </a>
              </el-row>
            </el-row>
          </el-card>
        </el-col>
      </el-row>

      <i
        class="iconfont icon-chevron-left arrow-left"
        @click="left"
        v-if="!isThree"
      ></i>
      <i
        class="iconfont icon-chevron-right arrow-right"
        @click="right"
        v-if="!isThree"
      ></i>
      <el-row
        :gutter="12"
        type="flex"
        justify="center"
        class="is-three-more"
        v-if="!isThree"
      >
        <el-col
          v-for="(item, index) in benchmarkCaseList"
          :key="index"
          ref="case"
          :style="{transform:'translateX('+currentOffset+'px)'}"
          style="padding-left:12px !important;padding-right:12px !important;transition:transform 0.5s"
        >
          <el-card
            shadow="hover"
            style="margin:11px"
          >
            <el-row class="solution-case-img"><img :src="item.imageUrl" /></el-row>
            <el-row class="solution-case-text">
              <el-row class="solution-title">{{ item.title }} </el-row>
              <el-row class="solution-text">{{ item.description }} </el-row>
              <el-row class="solution-btn">
                <a
                  :href="item.referringSite"
                  target="_blank"
                >
                  <el-button>查看详情</el-button>
                </a>
              </el-row>
            </el-row>
          </el-card>
        </el-col>
      </el-row>

    </el-row>
  </div>
</template>

<script>
import { getBenchmarkCaseList } from '@/api/landing'
export default {
  name: 'landSolutionCase',
  mounted () {
    // this.closeVideo()
    this.getList()
    // this.computeVideoSize()
  },
  data () {
    return {
      benchmarkCaseList: [],
      currentOffset: 0,
      isThree: true,
      widthNum: 0
    }
  },
  props: {},
  methods: {
    // 获取列表
    getList () {
      getBenchmarkCaseList()
        .then(res => {
          const { code, data, message } = res
          if (code === 200) {
            for (let index = 0; index < data.length; index++) {
              if (data[index].solution === '建设方') {
                this.benchmarkCaseList.push(data[index] || [])
              }
            }
            if (this.benchmarkCaseList.length > 3) {
              this.isThree = false
              this.widthNum = this.benchmarkCaseList.length - 3
            }
          } else {
            this.benchmarkCaseList = []
            message && this.$message.error(message)
          }
        })
        .catch(() => {
          this.benchmarkCaseList = []
        })
    },
    left () {
      if (this.currentOffset === 0) {
        return
      }
      this.currentOffset += 413
    },
    right () {
      if (this.currentOffset === (-413 * this.widthNum)) {
        return
      }
      this.currentOffset -= 413
    }
  }
}
</script>

<style lang="scss" scoped>
.arrow-left {
  font-size: 29px;
  line-height: 454px;
  cursor: pointer;
  position: absolute;
  margin-left: -39px;
  //取消竖线，内容不能被选择
  -webkit-user-select: none; /*谷歌 /Chrome*/
  -moz-user-select: none; /*火狐/Firefox*/
  -ms-user-select: none; /*IE 10+*/
  user-select: none;
}
.arrow-right {
  font-size: 29px;
  line-height: 454px;
  cursor: pointer;
  position: absolute;
  margin-left: 1209px;
  //取消竖线，内容不能被选择
  -webkit-user-select: none; /*谷歌 /Chrome*/
  -moz-user-select: none; /*火狐/Firefox*/
  -ms-user-select: none; /*IE 10+*/
  user-select: none;
}
.land-home-solutionBg {
  background: #f5f8fa;
}
.land-solution-case {
  width: 1200px;
  height: 740px;
  margin: auto;
  // background: #bfb1b7;
  ::v-deep .el-row {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .is-three-more {
    display: -webkit-box;
    overflow: hidden;
    margin-left: -19px !important;
  }
  ::v-deep .el-card {
    width: 366px;
    height: 454px;
    background: #ffffff;
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.16);
    // box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.16);
    border-radius: 6px;
    border:0px;
    .el-card__body {
      padding: 0px;
    }
  }
  ::v-deep .el-card:hover {
    box-shadow: 0px 7px 9px 0px rgba(0, 0, 0, 0.16);
  }
  ::v-deep .el-rol {
    width: auto;
  }
  ::v-deep .el-col-24 {
    width: auto;
    padding-left: 24px !important;
    padding-right: 24px !important;
  }

  .solution-case-title {
    height: 56px;
    font-size: 40px;
    // font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #181f42;
    line-height: 56px;
    text-align: center;
    margin-top: 78px;
    margin-bottom: 44px;
  }

  .isSolutionThree {
    ::v-deep .el-card {
      width: 366px;
    }
  }
  .solution-case-img {
    // width: 582px;
    height: 232px;
    background: #e3e3e3;
    border-radius: 6px 6px 0px 0px;
    img {
      // width: 582px;
      // height: 231px;
      width: 366px;
      height: 232px;
    }
  }
  .solution-case-text {
    ::v-deep .el-row {
      text-align: center;
    }
    .solution-title {
      // width: 281px;
      // margin: 26px auto 11px auto !important;
      // height: 44px;
      min-height: 44px;
      font-size: 16px;
      // font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #181f42;
      line-height: 22px;
      margin-top: 26px;
      margin-bottom: 11px;
      padding-left: 43px;
      padding-right: 42px;
    }
    .solution-text {
      width: 313px;
      margin: auto !important;
      min-height: 52px;
      font-size: 14px;
      // font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5c5c65;
      line-height: 26px;
      // padding-left: 35px;
      // padding-right: 30px;
      //控制显示文字的行数
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .solution-btn {
      margin-top: 23px;
      ::v-deep .el-button {
        line-height: 0;
        width: 110px;
        height: 33px;
        border-radius: 4px;
        border: 1px solid #4499ff;
        color: #4499ff;
        font-size: 14px;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
      ::v-deep .el-button:hover {
        background: #4499ff;
        color: #ffffff;
      }
    }
  }
}
</style>
